module.exports = __webpack_public_path__ + "./images/15178e3aec00e4cc2f8e84217f1902cb.webp";